import React from 'react';

const Error = () => {
  return <div>Something went wrong.</div>;
};

export default Error;
